import { type ReactElement } from 'react';
import { TdsBanner } from '@scania/tegel-react';
import { siteConfig, type SiteNotice } from '@/app/config/global';

interface SiteNoticeBannersProperties {
  readonly siteNotices?: readonly SiteNotice[];
}

const SiteNoticeBanners = ({
  siteNotices = siteConfig.siteNotices,
}: SiteNoticeBannersProperties): ReactElement | null => {
  if (siteNotices.length === 0) {
    return null;
  }

  return (
    <>
      {siteNotices.map((siteNotice) => (
        <TdsBanner
          key={siteNotice.id}
          data-testid={`site-notice-banner-${siteNotice.id}`}
          subheader={siteNotice.message}
          variant={siteNotice.variant}
          roleType="region"
        />
      ))}
    </>
  );
};

export default SiteNoticeBanners;
